import React from 'react'

import { DocumentElement } from './components/document-element/DocumentElement'
import TextElement from './topic-elements/TextElement'
import LinkElement from './topic-elements/LinkElement'
import { IElement } from './types/IElement'

import {
  TopicElementTypeEnum,
  QuizElementTypes
} from '../../../../types/TopicElementTypeEnum'

import { PersistedQuizElement } from './topic-elements/QuizElement'
import { MediaElement } from './components/video-element/components/MediaElement'
import classNames from 'classnames'
import { EmbeddedFileElement } from './topic-elements/embedded-file-element/EmbeddedFileElement'
import { ITopicInTopicStore } from 'types/Topic'
import { TopicElementModel } from 'front-end/src/graphql/private/PrivateSchemaTypes'

// @ts-expect-error
const elementTypeMap: Record<
  TopicElementTypeEnum,
  (props: Partial<TopicElementModel>) => JSX.Element | null
> = {
  [TopicElementTypeEnum.DOCUMENT]: (props) => (
    <DocumentElement {...props.data} />
  ),
  [TopicElementTypeEnum.TEXT]: (props) => (
    <TextElement content={props.data?.content as string} />
  ),
  [TopicElementTypeEnum.LINK]: (props) => (
    <LinkElement {...(props as TopicElementModel)} />
  ),
  [TopicElementTypeEnum.MEDIA]: (props) => {
    const content = props.data?.content
    return (
      <div
        className={classNames('VideoElement', {
          'VideoElement--audio':
            typeof content === 'string' && content.endsWith('mp3')
        })}
      >
        {/* @ts-expect-error */}
        <MediaElement {...props} />
      </div>
    )
  },
  [TopicElementTypeEnum.GOOGLE_DRIVE_FILE]: ({ data }) => {
    if (!data) {
      return null
    }
    return <EmbeddedFileElement {...data?.googleDriveFile} />
  },
  [TopicElementTypeEnum.MICROSOFT_FILE]: ({ data }) => {
    if (!data) {
      return null
    }
    return <EmbeddedFileElement {...data?.microsoftFile} />
  },
  [TopicElementTypeEnum.EMBED_LINK]: (props) => (
    <EmbeddedFileElement {...props.data} />
  )
}

type ViewElementProps = IElement & {
  allowRetry: boolean
  quizResponses: ITopicInTopicStore['enrolmentOrSelfEnrol']['quizResponses']
  isVisible?: boolean
  shouldTrackMedia?: boolean
  topicId: number
}

export const ViewElement = (props: ViewElementProps) => {
  const { type } = props

  return type && QuizElementTypes.includes(type as any) ? (
    <PersistedQuizElement {...(props as any)} />
  ) : (
    elementTypeMap[type](props)
  )
}
